import { Icon } from '../../icons';

interface FullscreenButtonProps {
  active: boolean;
  onToggle: () => void;
  className?: string;
}

/**
 * The Full screen / Exit full screen control. Presentational: the state comes
 * from `useFullscreen()` on the element being promoted, so a panel can show the
 * same control in two places (header and on-video) without two listeners
 * disagreeing.
 */
export default function FullscreenButton({ active, onToggle, className }: FullscreenButtonProps) {
  const label = active ? 'Exit full screen' : 'Full screen';
  return (
    <button
      type="button"
      className={className}
      // A Matrix cell focuses itself on click and the floating header starts a
      // drag on mousedown; neither should react to this button.
      onClick={(e) => { e.stopPropagation(); onToggle(); }}
      onMouseDown={(e) => e.stopPropagation()}
      title={label}
      aria-label={label}
    >
      <Icon name={active ? 'exit-fs' : 'fullscreen'} />
    </button>
  );
}
